import { postRequest } from "../utils/request";

export function getDownloadInfoFetch(params) {
  return postRequest("/v1/sys/update", params);
}

export function getSpeedTestResultInfoFetch(params) {
  return postRequest("/v1/networkspeed/query", params);
}
